import script from "./NavMain.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavMain.component.vue?vue&type=script&lang=ts&setup=true"

import "./NavMain.component.vue?vue&type=style&index=0&id=8c5cc472&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c5cc472"]])

export default __exports__